import React from "react";
//import Burger from "../navbar/hamburger/Burger";

const Logo = () => {
  return (
    <>
      <div className="logo">
        <div className="logo1">
          <div className="logo2">The</div>
          <div className="logo3">Siren</div>
        </div>
        {/* <Burger/> */}
      </div>
    </>
  );
};

export default Logo;
